var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-title"},[_c('span',{staticClass:"texts"},[_c('h5',{domProps:{"innerHTML":_vm._s(_vm.label)}}),_c('h2',{domProps:{"innerHTML":_vm._s(_vm.name)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }